import { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/solid";

interface TagsProps {
  id: string;
  label?: string;
  labelColour?: string;
  small?: string | null;
  className: string;
  placeholder?: string;
  showLabel?: boolean;
  state?: any;
  stateName?: any;
  handler: any;
}

export default function Tags({
  id,
  label,
  labelColour,
  small,
  className,
  placeholder,
  showLabel,
  state,
  stateName,
  handler,
}: TagsProps) {
  const tags = state[stateName];
  const [newTags, setNewTags] = useState("");

  function confirmNewTags(e: any) {
    e.preventDefault();
    const newTagsArray = newTags
      .split(",")
      .map((x) => x.trim())
      .filter((x) => x !== "");
    const newTagsToAdd = newTagsArray.filter((x: string) => !tags.includes(x));
    const updatedState = [...newTagsToAdd, ...tags];
    handler({ ...state, [stateName]: updatedState });
    setNewTags("");
  }

  function removeTag(e: any, tag: string) {
    e.preventDefault();
    const updatedState = tags.filter((x: string) => x !== tag);
    handler({ ...state, [stateName]: updatedState });
  }

  return (
    <div>
      {showLabel ? (
        <label
          htmlFor={id}
          className={`mb-${
            small === null ? 3 : 1
          } block text-left text-sm font-medium ${labelColour}`}
        >
          {label}
        </label>
      ) : (
        <label
          htmlFor={id}
          className={`mb-${
            small === null ? 3 : 1
          } block text-left text-sm font-medium ${labelColour}`}
        />
      )}
      {small !== null && (
        <p className="text-left mb-2 text-xs italic text-secondary">{small}</p>
      )}

      {/* Input form for tags */}
      <form onSubmit={confirmNewTags}>
        <input
          id={id}
          type="text"
          className={className}
          placeholder={placeholder}
          value={newTags}
          onChange={(e) => setNewTags(e.target.value)}
        />
      </form>

      <div className="hidden">
        <div className="absolute z-40 left-0 mt-2 w-full">
          <div className="py-1 text-sm bg-white rounded shadow-lg border border-gray-300">
            <a
              className="block py-1 px-5 cursor-pointer hover:bg-indigo-600 hover:text-white"
              href="#!"
            >
              Add tag "
              <span className="font-semibold" x-text="textInput"></span>"
            </a>
          </div>
        </div>
      </div>

      {/* Tag selections */}
      <div className="text-left">
        {tags.map((tag: string, idx: number) => (
          <div
            key={idx}
            className="hover:bg-primary-dark bg-primary inline-flex items-center text-sm rounded mt-2 mr-1 overflow-hidden"
          >
            <span
              className="ml-2 mr-1 leading-relaxed text-white truncate max-w-xs px-1"
              x-text="tag"
            >
              {tag}
            </span>
            <button
              className="p-1 inline-block align-middle focus:outline-none"
              onClick={(e) => removeTag(e, tag)}
            >
              <XMarkIcon className="w-4 h-4 text-white" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

Tags.defaultProps = {
  labelColour: "text-black",
  placeholder: "",
  small: null,
  showLabel: false,
  state: {},
  stateName: "",
};
